module.exports = "/_next/static/images/mobile_search_icon-dbe32849484a312a495ac231a820e5f9.svg";